export const CWAV__PRICE = '19.99';
export const DEFAULT_SHIPPING_COST = '4.95';
export const DEFAULT_PET_POISON_HOTLINE_PRICE = '99';
